export const userNotificationPathnames = {
  teamAnnouncements: '/teams/announcements',
  teamDocuments: '/teams/documents',
} as const;

export type UserNotificationPathname = (typeof userNotificationPathnames)[keyof typeof userNotificationPathnames];

export const hasUserNotification = (
  user: { notifications?: string[] } | null | undefined,
  pathname: UserNotificationPathname
) => user?.notifications?.includes(pathname) ?? false;
